import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { VideoRoom, ChatPanel } from "@/components/Consultation";
import { Logo, StatusBadge } from "@/components/common";
import { FullLoader } from "@/context/AuthContext";
import { fmtDT, useApi } from "@/lib/api";

export default function ConsultationRoom() {
  const { id } = useParams();
  const { data, loading, error, reload } = useApi(`/consultations/${id}/state`);
  if (loading && !data) return <FullLoader />;
  if (error) return <div className="p-10 text-center"><p className="text-red-600">{error}</p><Link to="/patient" className="text-sm text-[#2412B5]">Back</Link></div>;
  const a = data.appointment;
  const live = ["confirmed", "in_progress"].includes(a.status);
  return (
    <div className="min-h-screen bg-[#F7F9FA]">
      <header className="h-16 bg-white border-b border-[#E2E8ED] flex items-center justify-between px-4 sm:px-8">
        <div className="flex items-center gap-3"><Link to={`/patient/appointments/${id}`} aria-label="Back" data-testid="room-back-link"><ArrowLeft className="h-5 w-5" /></Link><Logo className="h-8" /></div>
        <StatusBadge status={a.status} testId="room-appt-status" />
      </header>
      <main className="mx-auto max-w-6xl p-4 sm:p-8 grid lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 space-y-3">
          <div><h1 className="text-xl font-semibold">{a.doctor_name}</h1><p className="text-sm muted">{a.specialty} · {fmtDT(a.start_at)} IST · Ref {a.ref}</p></div>
          {live ? <VideoRoom apptId={id} onChange={reload} /> : <div className="surface p-8 text-center text-sm muted" data-testid="room-closed">This consultation is {a.status.replace("_", " ")}.</div>}
          <p className="text-xs muted">If video fails, use the chat or report a technical issue to reschedule free of charge. Not for emergencies – call 112.</p>
        </div>
        <ChatPanel apptId={id} readOnly={!live} />
      </main>
    </div>
  );
}
